const TodoList = {
  GET_TODO_LIST: 'GET_TODO_LIST',
  GET_MAIN_SAMPLES: 'GET_MAIN_SAMPLES',
  GET_OTHER_SAMPLES_TODO_LIST: 'GET_OTHER_SAMPLES_TODO_LIST',
  CATEGORY: 'CATEGORY',
  SET_SAMPLE_REQUESTS_TODOLIST: 'SET_SAMPLE_REQUESTS_TODOLIST',
  SET_FILTER_SORT_DATA: 'SAMPLE_TODO_SET_FILTER_SORT_DATA',
  SET_TODO_LIST_COUNT: 'SET_TODO_LIST_COUNT',
  SET_SELECTED_IDS_ARRAY: 'SET_SELECTED_IDS_ARRAY',
};

export default TodoList;
